import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

// Capture the install prompt globally so any part of the app can offer "Install app".
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__pwaDeferred = e;
  window.dispatchEvent(new Event("pwa-can-install"));
});
window.addEventListener("appinstalled", () => { window.__pwaDeferred = null; });
